import React, { Component } from 'react';
import { Fade } from 'reactstrap';
import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import { hangupCallRequest, recordCallRequest, stopRecordCallRequest } from '../../../js/phone/actions';
import Button from '../../../components/formControls/Button';
import InterlocutorPanel from '../../../components/InterlocutorPanel';
import { isRecordCallAvailable, isRecording } from '../../../js/phone/selectors';
import { getMeId, hasGrants, hasRecordedCurrentCall } from '../../../js/me/selectors';
import Icon from '../../../components/icons/Icon';
import { showConfirmModal } from '../../../js/confirm/actions';

const messages = defineMessages({
  header: {
    id: 'MemberConferencePanel.header',
    defaultMessage: 'On going conference',
  },
  body: {
    id: 'MemberConferencePanel.body',
    defaultMessage: 'Conference',
  },
  startRec: {
    id: 'MemberConferencePanel.tooltip.startRec',
    defaultMessage: 'Start rec',
  },
  stopRecording: {
    id: 'MemberConferencePanel.tooltip.stopRecording',
    defaultMessage: 'Stop rec',
  },
  stopRecordingMessage: {
    id: 'MemberConferencePanel.stopRecordingMessage',
    defaultMessage:
      'Are you sure to stop recording? You cannot record again this conversation',
  },
});

class MemberConferencePanel extends Component {
  handleHangup = () => {
    this.props.hangup(this.props.callId);
  };

  handleRec = () => {
    this.props.recordCall({
      callId: this.props.callId,
      conference: true,
      users: [this.props.meId],
    });
  };

  handleStopRec = () => {
    this.props.confirm({
      message: this.props.intl.formatMessage(messages.stopRecordingMessage),
      modalAction: this.props.stopRecordCall,
      actionParams: {
        callId: this.props.callId,
        users: [this.props.meId],
      },
    });
  };

  render() {
    const {
      isRecordCallAvailable,
      canRecord,
      hasRecordedCurrentCall,
      recording,
      intl: { formatMessage },
    } = this.props;
    const record = isRecordCallAvailable && canRecord && !recording && !hasRecordedCurrentCall;
    return (
      <Fade id="ConferencePanelMember" className="card mt-2">
        <div className="card-header text-left small p-1">
          <div className="row">
            <div className="col-12">
              {this.props.intl.formatMessage(messages.header)}
            </div>
          </div>
        </div>
        <div className="card-body p-1 text-left small border-bottom">
          <InterlocutorPanel
            ellipsis
            interlocutor={{
              fullname: this.props.intl.formatMessage(messages.body),
              avatar: 'conference.svg',
              number: ' ',
            }}
          />
        </div>
        {(record || recording) && (
          <div className="card-body p-1 text-center small p-1">
            {record && (
              <span onClick={this.handleRec} className="mx-1">
                <Icon name="record-button" color="var(--yn-blue-dark)">
                  {formatMessage(messages.startRec)}
                </Icon>
              </span>
            )}
            {recording && (
              <span onClick={this.handleStopRec} className="mx-1">
                <Icon name="record-button-filled" color="var(--yn-blue-dark)">
                  {formatMessage(messages.stopRecording)}
                </Icon>
              </span>
            )}
          </div>
        )}
        <Button
          text="Hang up"
          className="bt btn-danger btn-block"
          onClick={this.handleHangup}
        />
      </Fade>
    );
  }
}
function mapStateToProps(state) {
  return {
    isRecordCallAvailable: isRecordCallAvailable(state),
    canRecord: hasGrants(state, 'PBX_REC'),
    hasRecordedCurrentCall: hasRecordedCurrentCall(state),
    recording: isRecording(state),
    meId: getMeId(state),
  };
}
export default injectIntl(
  connect(mapStateToProps, {
    hangup: hangupCallRequest,
    recordCall: recordCallRequest,
    stopRecordCall: stopRecordCallRequest,
    confirm: showConfirmModal,
  })(MemberConferencePanel)
);
